import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { BrowserLocalStorage, BrowserSessionStorage } from '../providers';
import * as i0 from "@angular/core";
import * as i1 from "../providers";
class NoopStorage {
  getItem(id) {
    return null;
  }
  setItem(id, data) {}
  removeItem(id) {}
}
export class StatePersistenceService {
  constructor(id, storage, useJson) {
    this.id = id;
    this.storage = storage;
    this.useJson = useJson;
  }
  get(defaultValue = null) {
    const data = this.storage.getItem(this.id);
    if (!data) return defaultValue;
    return data ? this.useJson ? JSON.parse(data) : data : defaultValue;
  }
  set(data) {
    this.storage.setItem(this.id, this.useJson ? JSON.stringify(data) : data);
  }
  update(data) {
    if (!this.useJson) throw new Error('StatePersistenceService.update() can only be used when configurated to use JSON!');
    const prevData = this.get() || {};
    const newData = {
      ...prevData,
      ...data
    };
    this.storage.setItem(this.id, JSON.stringify(newData));
  }
  remove() {
    this.storage.removeItem(this.id);
  }
}
export let PersistStateFactory = /*#__PURE__*/(() => {
  class PersistStateFactory {
    constructor(platformId, sessionStorage, localStorage) {
      this.platformId = platformId;
      this.sessionStorage = sessionStorage;
      this.localStorage = localStorage;
      this.isBrowser = isPlatformBrowser(this.platformId);
    }
    create(key, useJson = true, type = 'local') {
      if (type === 'local') return new StatePersistenceService(key, this.localStorage, useJson);else return new StatePersistenceService(key, this.sessionStorage, useJson);
    }
    static {
      this.ɵfac = function PersistStateFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PersistStateFactory)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(i1.BrowserSessionStorage), i0.ɵɵinject(i1.BrowserLocalStorage));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: PersistStateFactory,
        factory: PersistStateFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PersistStateFactory;
})();